/**
 * Checks to see if current setting has data.
 *
 * @param {array} tableData - The array of row data to be filtered.
 * @param {string} activePenalty - The displayed penalty type.
 * @returns {array} tableData - The filter array of table rows.
 */
export default function doDataCheck(
  activePenalty,
  dataPoints
) {
  return 0 < dataPoints.filter((dataPoint) => { // eslint-disable-line arrow-body-style
    return activePenalty === dataPoint.type;
  }).length;
}
